let chosenDownloadWayIndex = 0;

function moveElementInArray<T>(mutableArray: T[], fromIndex: number, toIndex: number): void {
	const element = mutableArray[fromIndex];
	mutableArray.splice(fromIndex, 1);
	mutableArray.splice(toIndex, 0, element);
}

export async function downloadFile(url: string, fallbackFileName: string): Promise<void> {
	const FILENAME_REGEX = /filename="(.*?)"/gi;

	try {
		const requestInits: [requestInit: RequestInit, originalIndex: number][] = [
			[{ method: 'get', mode: 'cors', referrerPolicy: 'no-referrer', credentials: 'include' }, 0],
			[{ method: 'get', mode: 'no-cors', referrerPolicy: 'no-referrer', credentials: 'include' }, 1],
			[{ method: 'get', mode: 'cors', referrerPolicy: 'no-referrer', credentials: 'omit' }, 2],
			[{ method: 'get', mode: 'no-cors', referrerPolicy: 'no-referrer', credentials: 'omit' }, 3],
		];

		moveElementInArray(requestInits, chosenDownloadWayIndex, 0);

		let response: Response | null = null;
		for (let index = 0; index < requestInits.length; index++) {
			const [requestInit, originalIndex] = requestInits[index];

			try {
				const potentialResponse = await fetch(url, requestInit);
				if (!potentialResponse.ok) continue;

				// If the response is ok, store the preferred RequestInit config so it
				// may be used next time.
				response = potentialResponse;
				chosenDownloadWayIndex = originalIndex;

				break;
			} catch {
				// Try with another one ...
			}
		}

		// If all fails, too bad :(
		if (response == null) {
			throw new Error(`Could not fetch the file from the url: ${url}`);
		}

		const blob = await response.blob();

		let fileName = '';

		const contentDisposition = response.headers.get('content-disposition');
		if (contentDisposition) {
			const filenameMatch = FILENAME_REGEX.exec(contentDisposition);

			// Using [1] to get the group value
			if (filenameMatch !== null && filenameMatch[1]) {
				fileName = filenameMatch[1];
			}
		}

		// If the contentDisposition getting fails, default to fileName
		if (fileName === '') {
			fileName = fallbackFileName;
		}

		const blobUrl = URL.createObjectURL(blob);
		const link = document.createElement('a');
		link.setAttribute('href', blobUrl);
		link.setAttribute('download', fileName);
		link.setAttribute('target', '__blank');
		link.setAttribute('rel', 'noreferrer');

		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	} catch (error: unknown) {
		// TODO: attach our logger.

		console.error(error);

		throw error;
	}
}
